var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { BaseTemplate } from "./base-template";
import { RouterConstants } from "../../../configuration/router.constants";
import { NotificationType } from "../../../services/basics/notification-client.service";
import * as Enumerable from "linq";
import { LookupValueRequest, LookupValueQuery } from "../../../models/lookups/lookup.models";
import { Messages } from "../../../configuration/event-messages.constants";
var BaseAgentWinningClaims = /** @class */ (function (_super) {
    __extends(BaseAgentWinningClaims, _super);
    function BaseAgentWinningClaims(eventAggrigator, router, lotteryClientService, tokenClient, i18N, dialogClientService, notificationClientService, lookupClientService) {
        var _this = _super.call(this, router, i18N, lotteryClientService, dialogClientService, tokenClient) || this;
        _this.eventAggrigator = eventAggrigator;
        _this.router = router;
        _this.lotteryClientService = lotteryClientService;
        _this.notificationClientService = notificationClientService;
        _this.lookupClientService = lookupClientService;
        _this.filter = null;
        _this.items = [];
        _this.statuses = [];
        _this.loadingWinningClaims = true;
        _this.currentPage = 0;
        _this.closePopup = function () {
            _this.items.forEach(function (x) { return x.isVisible = false; });
        };
        _this.onKeyDown = function (event) {
            if (event.keyCode == 13) // Enter
             {
                event.stopPropagation();
                _this.currentPage = 0;
                _this.items = [];
                _this.loadPurchasedItems();
            }
        };
        _this.stopPropagation = function (e) {
            e.stopPropagation();
            e.preventDefault();
        };
        return _this;
    }
    BaseAgentWinningClaims.prototype.activate = function (params) {
        if (!this.tokenClient.isAuthenticated && !this.tokenClient.isPreview) {
            this.router.navigateToRoute(RouterConstants.RouteNames.Lobby, {});
        }
        else {
            var promise = _super.prototype.activate.call(this, params);
            this.loadPurchasedItems();
            this.loadStatuses();
            return promise;
        }
    };
    BaseAgentWinningClaims.prototype.showTicketDialog = function (item) {
        var _this = this;
        this.clientLotteryClientService.getMyPurchases(0, item.transactionId, null, null).then(function (purchase) {
            var templateName = _this.tokenClient.user.templateName.toLowerCase();
            try {
                require("./" + templateName + "/dialogs/ticket-dialog");
            }
            catch (_a) {
                console.log("Cannot load ticket dialog for template " + templateName);
            }
            _this.dialogClient.show("app/styles/client/templates/" + templateName + "/dialogs/ticket-dialog", purchase.items[0], true, true);
        });
    };
    BaseAgentWinningClaims.prototype.currentTimeFilterChanged = function () {
        this.currentPage = 0;
        this.items = [];
        this.loadPurchasedItems();
    };
    BaseAgentWinningClaims.prototype.loadStatuses = function () {
        var _this = this;
        var request = new LookupValueRequest();
        request.lookupValueQuery = LookupValueQuery.agentWinningClaimPayoutStatuses;
        this.lookupClientService.getLookup(request).then(function (x) {
            var e_1, _a;
            _this.statuses = [];
            try {
                for (var _b = __values(x.values), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var value = _c.value;
                    var item = value;
                    _this.statuses.push(item);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    };
    BaseAgentWinningClaims.prototype.loadPurchasedItems = function () {
        var _this = this;
        if (this.moreToLoad) {
            this.loadingMore = true;
        }
        this.lotteryClientService.getAgentWinningClaims(this.currentPage, this.filter, this.currentTimeFilter.dateFrom).then(function (x) {
            var e_2, _a;
            _this.moreToLoad = x.moreToLoad;
            _this.totalPaid = x.totalPaid;
            _this.totalPending = x.totalPending;
            _this.totalPayouts = x.totalPayouts;
            try {
                for (var _b = __values(x.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    _this.items.push(item);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            _this.loadingWinningClaims = false;
            _this.loadingMore = false;
        }, function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
    };
    BaseAgentWinningClaims.prototype.attached = function () {
        _super.prototype.attached.call(this);
        if (this.searchinput)
            this.searchinput.addEventListener("keydown", this.onKeyDown, false);
        this.subscriptionToDocumentClickEvent = this.eventAggrigator.subscribe(Messages.documentClick, this.closePopup);
    };
    BaseAgentWinningClaims.prototype.detached = function () {
        _super.prototype.detached.call(this);
        if (this.searchinput)
            this.searchinput.removeEventListener("keydown", this.onKeyDown, false);
        if (this.subscriptionToDocumentClickEvent) {
            this.subscriptionToDocumentClickEvent.dispose();
        }
    };
    BaseAgentWinningClaims.prototype.showPopup = function (item, event) {
        item.isVisible = true;
        event.stopPropagation();
    };
    BaseAgentWinningClaims.prototype.hidePopup = function (item, event) {
        item.isVisible = false;
        event.stopPropagation();
    };
    BaseAgentWinningClaims.prototype.save = function (item) {
        var _this = this;
        var status = Enumerable.from(this.statuses).firstOrDefault(function (x) { return x.isSelected; });
        ;
        item.agentPayoutStatus = status.name;
        item.agentPayoutStatusId = status.id;
        item.isVisible = false;
        item.agentPaymentUpdateStatusDate = new Date();
        this.clientLotteryClientService.changeWinningClaimPayoutStatus(item.winningClaimId, status.id).then(function (x) {
            _this.notificationClientService.show("Success", "Successfully saved winning claim", NotificationType.Success);
        }, function (e) {
            _this.notificationClientService.show("Error", "Failed to save winning claim", NotificationType.Error);
        });
    };
    BaseAgentWinningClaims.prototype.toggleSearch = function () {
        this.searchOpened = !this.searchOpened;
        if (this.searchOpened) {
            this.searchinput.focus();
        }
    };
    BaseAgentWinningClaims.prototype.clearSearch = function () {
        this.filter = "";
        this.currentPage = 0;
        this.items = [];
        this.loadPurchasedItems();
    };
    return BaseAgentWinningClaims;
}(BaseTemplate));
export { BaseAgentWinningClaims };
